import { render } from "./chevron-up.vue?vue&type=template&id=5ad7b8d7"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/chevron-up.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ad7b8d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ad7b8d7', __exports__)) {
    api.reload('5ad7b8d7', __exports__)
  }
  
  module.hot.accept("./chevron-up.vue?vue&type=template&id=5ad7b8d7", () => {
    api.rerender('5ad7b8d7', render)
  })

}


export default __exports__